import { Heading } from '@apia/theme';
import { usePanelIdentity } from '../common';

export const ContainerNotFound = () => {
  const props = usePanelIdentity();

  return <Heading>Container not found for panel: {props.panelName}</Heading>;
};
